(function(algolia) {
  'use strict';
  var rangeSlider = algolia.externals.widgets.rangeSlider;
  var menu = algolia.externals.widgets.menu;
  var refinementList = algolia.externals.widgets.refinementList;
  var translations = algolia.translations;

  var TYPES_TO_WIDGET = {
    slider: { name: 'rangeSlider', useDefault: true, widget: rangeSlider },
    menu: { name: 'menu', params: { limit: 10 }, widget: menu },
    conjunctive: {
      name: 'refinementList',
      params: { operator: 'and', limit: 10 },
      widget: refinementList,
    },
    disjunctive: {
      name: 'refinementList',
      params: { operator: 'or', limit: 10 },
      widget: refinementList,
    },
  };

  var sortByRefined = function sortByRefined(sortFunction) {
    return function(a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) return -1;
        if (b.refined) return 1;
      }
      return sortFunction(a, b);
    };
  };

  algolia.facetSortFunctions = {
    price_range: sortByRefined(function sortRanges(a, b) {
      if (a.name.length === b.name.length) return a.name.localeCompare(b.name);
      return a.name.length - b.name.length;
    }),
  };

  algolia.facetDisplayFunctions = {
    price_range: function displayRange(value) {
      var values = value.split(':');
      return values
        .map(e => {
          return algolia.formatMoney(Number(e) * 100).replace(/\.\d+/, '');
        })
        .join(' - ');
    },
  };

  algolia.facetCssClasses = {
    root: 'ais-facet',
    header: 'ais-facet--header',
    body: 'ais-facet--body',
    item: 'ais-facet--item',
    label: 'ais-facet--label',
    checkbox: 'ais-facet--checkbox',
    active: 'ais-facet--active',
    count: Boolean(algolia.config.show_products) ? 'ais-facet--count-distinct' : 'ais-facet--count',
  };

  var enabledFacets = algolia.config.facets.filter(facet => {
    return facet.enabled || parseInt(facet.enabled, 10);
  });

  algolia.facets = enabledFacets.map(facet => {
    const facetTitle = translations?.facets?.find(f => f.name === facet.name);
    const title = facetTitle ? facetTitle.title : facet.title;
    return {
      ...facet,
      title: title,
      escapedName: encodeURIComponent(facet.name),
    };
  });

  algolia.shownFacets = algolia.facets.filter(facet => facet.type !== 'hidden');
  algolia.hiddenFacets = algolia.config.facets.filter(facet => facet.type === 'hidden');

  var toHandle = function(input) {
    return String(input || '')
      .trim()
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  var isColourFacet = function(facet) {
    if (!facet) return false;
    if (facet.title && String(facet.title).toLowerCase() === 'colour') return true;
    if (facet.name && String(facet.name).toLowerCase().includes('colour')) return true;
    if (facet.escapedName && String(facet.escapedName).toLowerCase().includes('colour')) return true;
    return false;
  };

  /**
   * Files base URL (Liquid)
   */
  algolia.swatchFileBaseUrl = algolia.swatchFileBaseUrl || (function() {
    var example = "//shop.leachs.com/cdn/shop/files/example.png?v=37774";
    return example.replace(/example\.png(\?.*)?$/i, '');
  })();

  /**
   * Build possible filenames in order:
   * 1) Title Case / original case: "Fluorescent Yellow" -> "Fluorescent-Yellow.png"
   * 2) lower-handle: "fluorescent-yellow.png"
   */
  var buildSwatchUrls = function(cleanName) {
    var urls = [];
    if (!algolia.swatchFileBaseUrl) return urls;

    var preferred = cleanName.replace(/\s+/g, '-') + '.png';
    var fallback = toHandle(cleanName) + '.png';

    urls.push(algolia.swatchFileBaseUrl + preferred);

    if (fallback !== preferred) {
      urls.push(algolia.swatchFileBaseUrl + fallback);
    }

    return urls;
  };

  var renderColourSwatchItem = function(item, html) {
    var rawValue = item && (item.label || item.value || item.name) ? (item.label || item.value || item.name) : '';
    var cleanName = String(rawValue)
      .replace(/^colour[_-]/i, '')
      .replace(/^color[_-]/i, '')
      .trim();

    var tagHandle = toHandle(cleanName);
    var finalTag = 'colour_' + tagHandle;

    var isWhite = tagHandle === 'white' || tagHandle === 'blanc';

    var bgColor = cleanName.replace(/\s+/g, '');

    var urls = buildSwatchUrls(cleanName);

    var style = 'background-color: ' + bgColor + ';';
    if (urls.length) {
      // Multiple backgrounds: browser will try first, then next if it fails.
      style += ' background-image: ' + urls.map(u => 'url(' + u + ')').join(', ') + ';';
    }

    var selectedClass = item.isRefined ? 'is-selected' : '';
    var whiteClass = isWhite ? 'color-swatch--white' : '';

    return html`
      <div class="color-swatch ${whiteClass}" data-tooltip="${cleanName}">
        <a
          href="${item.url}"
          class="color-swatch__button ${selectedClass}"
          aria-label="${cleanName}"
          data-tag="${finalTag}"
          data-tag-user="${cleanName}"
          role="button"
        >
          <span class="color-swatch__item" style="${style}"></span>
        </a>
      </div>
    `;
  };

  
  var facetToWidget = function(facet) {
    var widget = TYPES_TO_WIDGET[facet.type];
    var params = algolia.assign({}, widget.params);

    params.container = "[class~='ais-facet-" + facet.escapedName + "-container']";
    params.attribute = facet.name;
    params.templates = {};
    params.cssClasses = algolia.facetCssClasses;

    params.templates.showMoreText = function showMoreText(data, {html}) {
      return algolia.instantSearchShowMore(data, html);
    };

    if (facet.searchable) {
      params.searchable = true;
      params.searchablePlaceholder = 'Search for ' + facet.title;
      params.templates.searchableNoResults = '<div> No matching for ' + facet.title + '</div>';
    }

    params.templates.header = function() {
      return facet.title;
    };

    var displayFunction = algolia.facetDisplayFunctions[facet.name];
    params.transformItems = function(items) {
      return items.map(item => ({
        ...item,
        type: facet.type,
        label: displayFunction ? displayFunction(item.value) : item.value
      }));
    };

    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name];
    }

    if (isColourFacet(facet) && (facet.type === 'conjunctive' || facet.type === 'disjunctive')) {
      params.templates.item = function(item, {html}) {
        return renderColourSwatchItem(item, html);
      };
    } else if (!widget.useDefault) {
      params.templates.item = (item, {html}) => {
        return algolia.instantSearchFacetItem(item, html);
      };
    }

    return {
      name: widget.name,
      params: params,
      widget: widget.widget,
    };
  };

  var collection_facets =
    algolia.current_collection_id &&
    algolia.config.collection_facets &&
    algolia.config.collection_facets[algolia.current_collection_id]
      ? algolia.config.collection_facets[algolia.current_collection_id]
      : algolia.config.collection_facets &&
        algolia.config.collection_facets.default;

  if (collection_facets) {
    var enabledCollectionFacets = collection_facets.filter(facet => {
      return facet.enabled || parseInt(facet.enabled, 10);
    });

    algolia.collectionFacets = enabledCollectionFacets.map(facet => ({
      ...facet,
      escapedName: encodeURIComponent(facet.name)
    }));

    algolia.collectionShownFacets = algolia.collectionFacets.filter(facet => facet.type !== 'hidden');
    algolia.collectionHiddenFacets = collection_facets.filter(facet => facet.type === 'hidden');
    algolia.collectionFacetsWidgets = algolia.collectionShownFacets.map(facetToWidget);
  }

  algolia.facetsWidgets = algolia.shownFacets.map(facetToWidget);
})(window.algoliaShopify);